import { useMemo } from 'react';
import { Table } from 'altus-ui-components';
import { EMPTY_LIST, Format } from 'app/app.constants';
import moment from 'moment';
import { fromJS } from 'immutable';
import DownloadIcon from '@material-ui/icons/GetApp';
import DeleteIcon from '@material-ui/icons/Delete';
import { IconButton } from '@material-ui/core';

const LogFilesTable = ({ corrosionLogs, downloadLog, deleteLog }) => {
  const columns = useMemo(
    () => [
      {
        xs: 5,
        Header: 'File Name',
        accessor: (log) => log.get('fileName'),
      },
      {
        xs: 2,
        Header: 'Service Provider',
        accessor: (log) => {
          let serviceProvider = log.get('serviceProvider');
          return serviceProvider.get('name');
        },
      },
      {
        xs: 2,
        Header: 'Tool',
        accessor: (log) => {
          let toolUsed = log.get('toolUsed');
          return toolUsed.get('name');
        },
      },
      {
        xs: 2,
        Header: 'Log Date',
        accessor: (log) => {
          let date = moment(log.get('logDate'));
          return date.format(Format.date_dayfirst);
        },
      },
      {
        xs: 2,
        Header: 'Uploaded By',
        accessor: (log) => {
          let userUploaded = log.get('uploadedByUser');
          return userUploaded.get('fullName');
        },
      },
      {
        xs: 2,
        id: 'delete',
        Cell: ({ row }) => {
          const log = row.original;
          return (
            <>
              <IconButton
                color="inherit"
                onClick={() => downloadLog(log.get('id'))}
                aria-label="Delete"
              >
                <DownloadIcon fontSize="small" />
              </IconButton>
              <IconButton
                title="Close"
                color="inherit"
                onClick={() => deleteLog(log.get('id'))}
                aria-label="Close"
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </>
          );
        },
      },
    ],
    [deleteLog, downloadLog],
  );

  return (
    <>
      <Table
        subrowOffset={3}
        items={corrosionLogs ? fromJS(corrosionLogs) : EMPTY_LIST}
        columns={columns}
        useGlobalFilter={true}
        noItemsMessage="No Log File has been added yet."
      />
    </>
  );
};

export default LogFilesTable;
